<script setup lang="ts">
import type { ResolvedSelfSellInModel } from '../../composables/useSelfSellIn';
import SectionContainer from '../SectionContainer.vue';
import SectionHeader from '../SectionHeader.vue';
import CatalogCard from './CatalogCard.vue';
import PricatSection from './PricatSection.vue';

defineProps<{
  data: NonNullable<ResolvedSelfSellInModel['catalogDownloadSection']>;
}>();
</script>

<template>
  <SectionContainer :section-title="data.title">
    <SectionHeader :title="data.title" :description="data.description" />
    <div class="catalogs">
      <CatalogCard
        v-for="catalog in data.catalogs"
        :key="catalog.title"
        :data="catalog"
        :id="`download-${catalog.type}`" />
    </div>
    <PricatSection :season="data.season" />
  </SectionContainer>
</template>

<style lang="scss" scoped>
.catalogs {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(265px, 100%), 1fr));
  gap: 4px;

  @include respond-to('tablet') {
    grid-template-columns: repeat(auto-fit, minmax(30%, 1fr));
  }
}
</style>
